/**
 * Generates a consistent calendar color from a subscription ID.
 * Uses a hash to pick a hue, then adapts to light/dark mode
 * using the current theme's surface colors via CSS color-mix.
 */

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/** Returns a persistent color for a given subscription ID, or the stored override color */
export function getCalendarColor(id: string, storedColor?: string | null): string {
  if (storedColor) return storedColor;
  const index = hashString(id) % CALENDAR_COLOR_PRESETS.length;
  return CALENDAR_COLOR_PRESETS[index].value;
}

/** Returns a tinted background suitable for event cards */
export function getCalendarBg(id: string, storedColor?: string | null): string {
  const color = storedColor ?? CALENDAR_COLOR_PRESETS[hashString(id) % CALENDAR_COLOR_PRESETS.length].value;
  return `color-mix(in srgb, ${color} 15%, transparent)`;
}

/** Pastel color presets — hex values (light mode). Stored colors are always hex. */
export const CALENDAR_COLOR_PRESETS: Array<{ label: string; value: string }> = [
  { label: 'Mist Blue',  value: '#E3E8ED' },
  { label: 'Lavender',   value: '#E0DDE6' },
  { label: 'Rose',       value: '#EAD7D7' },
  { label: 'Sage',       value: '#D4DAD4' },
  { label: 'Teal',       value: '#D6E2E1' },
  { label: 'Sand',       value: '#EFE4D5' },
  { label: 'Petal',      value: '#E9E1E8' },
  { label: 'Barley',     value: '#EDEADB' },
  { label: 'Terracotta', value: '#E8D9D1' },
  { label: 'Ink',        value: '#DCE4E8' },
];
